import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { NavigateLinks } from '@/components';

import { createServiceVisitTypeBreadcrumbs } from '../config';
import { ServiceVisitTypeForm } from '../components';
import { useCreateServiceVisitType } from '../hooks';

const NewServiceVisitType = () => {
  const navigate = useNavigate();
  const { handleCreate, isCreating } = useCreateServiceVisitType();

  const breadcrumbs = useMemo(
    () => createServiceVisitTypeBreadcrumbs(navigate),
    [navigate]
  );

  return (
    <section className='flex flex-col gap-6 w-full h-full'>
      <NavigateLinks
        actualPage='Nuevo tipo de visita'
        breadcrumbs={breadcrumbs}
      />
      <ServiceVisitTypeForm
        onSubmit={handleCreate}
        isSubmitting={isCreating}
        submitLabel='Crear tipo de visita'
      />
    </section>
  );
};

export default NewServiceVisitType;
